import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Item from '../../../components/itens/item'


function OrgaosScreen() {
    return (
        <Fragment>
            <Head titulo="Defesa Civil de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/orgaos'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <Item
                            titulo={"Plano de Contingência de 2024/2025 de Macuco"}
                            descricao={"Veja aqui o Plano de Contingência Unificado para o biênio 2024/2025 elaborado pela Defesa Civil de nosso município."}
                            awesome={"faTowerBroadcast"}
                            link={"../arquivos/docs/Plano-de-Contingencia Macuco-RJ-2024-2025.pdf"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Plano de Contingência de Seca 2025 de Macuco"}
                            descricao={"Veja aqui o Plano de Contigência do Município de Macuco para Incêndio Florestais e Estiagem de 2025"}
                            awesome={"faHandHoldingWater"}
                            link={"../arquivos/docs/PLANCON SECA - 2025.pdf"}
                            key={2}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OrgaosScreen;